<template>
  <div class="text-center">
      <v-card>
        <v-container>
          <v-row justify="center" class="col-12">
            <v-col cols="12" align="center">
              <v-icon @click="cancelForm" class="float-right">mdi-close</v-icon>
              <h1 class="text-center">{{title}}</h1>
              <v-form
                ref="form"
                v-model="formValid"
              >
                <v-row class="col-12">
                  <v-col cols="6">
                <v-text-field
                  color="error"
                  v-model="form.name"
                  label="Název jídla"
                  prepend-icon="mdi-form-textbox"
                  :rules="[rules.required]"
                  required
                  outlined
                ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                <v-text-field
                  color="error"
                  v-model="form.internalName"
                  label="Interní název jídla"
                  prepend-icon="mdi-form-textbox"
                  :rules="[rules.required]"
                  outlined
                  required>
                </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      color="error"
                      label="Alergeny"
                      v-model="form.alergens"
                      :items="alergens"
                      :search-input.sync="search"
                      item-text="name"
                      prepend-icon="mdi-pill"
                      return-object
                      hide-selected
                      multiple
                      persistent-hint
                      small-chips
                      deletable-chips
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                <v-text-field
                  color="error"
                  v-model="form.weight"
                  prepend-icon="mdi-weight-gram"
                  label="Gramáž"
                  :rules="[rules.required, rules.number]"
                  outlined
                  required>
                </v-text-field>
                  </v-col>
                  <v-col cols="6">
                <v-text-field
                  color="error"
                  v-model="form.calories"
                  prepend-icon="mdi-food"
                  label="Kalorie"
                  :rules="[rules.number, rules.required]"
                  required
                  outlined>
                </v-text-field>
                  </v-col>
                  <v-col cols="6">
                <v-select
                  color="error"
                  label="Vyberte typ stravy"
                  prepend-icon="mdi-format-list-bulleted"
                  v-model="form.foodTypes"
                  :items="foodTypes"
                  item-text="name"
                  :search-input.sync="search"
                  return-object
                  :rules="[rules.required]"
                  hide-selected
                  multiple
                  persistent-hint
                  small-chips
                  deletable-chips
                  outlined
                ></v-select>
                  </v-col>
                  <v-col cols="6">
                <v-select
                  color="error"
                  label="Vyberte denní dobu"
                  prepend-icon="mdi-clock-time-eight-outline"
                  v-model="form.timeTypes"
                  :items="timeTypes"
                  item-text="name"
                  return-object
                  :rules="[rules.required]"
                  :search-input.sync="search"
                  hide-selected
                  multiple
                  persistent-hint
                  small-chips
                  deletable-chips
                  outlined
                ></v-select>
                  </v-col>
                  <v-col cols="6">
                <v-text-field
                  color="error"
                  v-model="form.price"
                  prepend-icon="mdi-cash"
                  label="Cena"
                  :rules="[rules.required, rules.number]"
                  outlined
                  required>
                </v-text-field>
                  </v-col>
                  <v-col cols="6">
                <v-file-input
                  label="Vybrat fotografii"
                  v-model="photo"
                  counter="true"
                  show-size
                  :rules="[rules.maxSize(1000000)]"
                  outlined
                  prepend-icon="mdi-camera">
                </v-file-input>
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox
                      v-model="form.specialOffer"
                      label="Akční nabídka"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="6">
                <v-checkbox
                  v-model="dataChecked"
                  label="Data jsou zkontrolována"
                  :rules="[rules.checked]"
                  required>
                </v-checkbox>
                  </v-col>
                  <v-col cols="12" class="text-right">
                <v-btn
                  :disabled="!formValid || wait"
                  color="warning"
                  class="mr-4"
                  @click="save"
                >
                  Zapsat
                </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  name: 'FoodForm',
  props: ['item', 'alergens', 'foodTypes', 'timeTypes'],
  mixins: [rules],
  data () {
    return {
      wait: false,
      dialog: false,
      search: null,
      form: {
        ...this.item,
        price: this.item.price.toString(),
        weight: this.item.weight.toString(),
        calories: this.item.calories.toString()
      },
      photo: null,
      dataChecked: false,
      formValid: true
    }
  },
  computed: {
    title () {
      return this.item.id ? 'Upravit jídlo' : 'Přidat jídlo'
    }
  },
  methods: {
    cancelForm () {
      this.$emit('formCanceled')
    },
    save () {
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      })
      this.wait = true
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/foods${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase(this.form)
      }
      this.$http(options)
        .then(response => {
          const foodId = response.data.id
          const foodName = response.data.name
          if (this.photo) {
            const formData = new FormData()
            formData.append('image', this.photo, this.photo.name)
            formData.append('food_id', foodId)
            formData.append('name', foodName)

            const photoOptions = {
              method: 'post',
              url: '/admin/foods/upload',
              data: formData
            }
            this.$http(photoOptions)
              .then(() => {
                this.$emit('data-saved')
              })
              .catch(err => { console.log(err) })
          } else {
            this.$emit('data-saved')
          }
        })
        .catch(err => {
          this.wait = false
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>
